import UserService from '@/services/UserService';

// Shared user-avatar helpers (initials, cache-backed resolution, cache fill).
// Consumers must expose `store` (Pinia DefaultStore) with the reactive
// `loadedUsersData` map — the same one used across the app for avatars.
export default {
    methods: {
        ComputeInitials(fullName){
            const parts = (fullName ?? '').trim().split(' ').filter(Boolean);
            const initials = parts.length >= 2
                ? (parts[0][0] ?? '') + (parts[1][0] ?? '')
                : (parts[0]?.[0] ?? '');
            return initials.toUpperCase();
        },

        ResolveUserData(pkUser, fullName){
            const stored = this.store.loadedUsersData[pkUser];
            if(stored) return stored;
            return { PKUser: pkUser, ProfilePictureURL: null, Initials: this.ComputeInitials(fullName), Name: fullName };
        },

        // Fetches any not-yet-cached users into the shared reactive cache.
        // Fire-and-forget friendly: ignores falsy PKs, dedups, and swallows
        // errors so avatar loading never blocks the caller.
        async LoadUsersDataIntoCache(pks){
            const missing = [...new Set((pks ?? []).filter(Boolean))]
                .filter(pk => !this.store.loadedUsersData[pk]);
            if(missing.length === 0) return;

            await UserService.GetUsersMessageData({ usersPKs: missing })
                .then(data => {
                    data.Users.forEach(user => {
                        this.store.loadedUsersData[user.PKUser] = user;
                    });
                })
                .catch(() => {});
        }
    }
};
